module.exports = __webpack_public_path__ + "static/media/marina.8b35b459.svg";